import * as React from 'react';
import { Button, Dialog, Intent } from '@blueprintjs/core';

interface IProps {
    isOpen: boolean;
    handleConfirmQuit: () => void;
    handleAbortQuit: () => void;
    message: string;
    title: string;
}

export default function ConfirmClose(props: IProps) {
    return (
        <Dialog isOpen={props.isOpen} title={props.title} onClose={props.handleAbortQuit}>
            <div className='bp4-dialog-body'>
                <TextAsParagraphs text={props.message}/>
            </div>
            <div className='bp4-dialog-footer'>
                <div className='bp4-dialog-footer-actions'>
                    <Button
                        intent={Intent.NONE}
                        onClick={props.handleAbortQuit}
                        large={true}
                    >
                        Cancel
                    </Button>
                    <Button
                        intent={Intent.DANGER}
                        onClick={props.handleConfirmQuit}
                        large={true}
                    >
                        Confirm Quit
                    </Button>
                </div>
            </div>
        </Dialog>
    );
}

function TextAsParagraphs(props: { text: string }) {
    return <>{props.text.split('\n').map((item, i) => <p key={i}>{item}</p>)}</>;
}
